export enum RoleEnum {
    SUPER_ADMIN = "super_admin",
    ASP_ADMIN = "asp_admin",
    LMS_ADMIN = "lms_admin",
    ESTABLISHMENT_MANAGER = "establishment_manager",
    EMPLOYEE = "employee",
    ADMINISTRATOR_DEVIATIONS = "administrator_deviations",
}

export const RoleEnumLabel: Record<RoleEnum, string> = {
    [RoleEnum.SUPER_ADMIN]: "Super admin",
    [RoleEnum.ASP_ADMIN]: "ASP admin",
    [RoleEnum.LMS_ADMIN]: "LMS admin",
    [RoleEnum.ESTABLISHMENT_MANAGER]: "Vestigingsmanager",
    [RoleEnum.EMPLOYEE]: "Medewerker",
    [RoleEnum.ADMINISTRATOR_DEVIATIONS]: "Beheerder afwijkingen",
};
